module.exports = __webpack_public_path__ + "images/icons/flags/DE-47a9655b.svg";